






import { useEffect, useState } from "react";
import { Box, Chip, IconButton, Typography 
,
  Card,
  CardContent,
  
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,Stack


} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom"; 
import VisibilityIcon from "@mui/icons-material/Visibility";
import ReactTable from "../../components/common/ReactTable"; 
// import VisitDetailDialog from "./VisitDetailDialog"; 
import ApiCallService from "../../Service/ApiCallService";
import { resolveElements } from "framer-motion";

const SadhuSadhviVisitView = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const [selected, setSelected] = useState(null);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();   
  const handleOpen = (row) => {
    setSelected(row);
   // setOpen(true);
   navigate(`/sadhuSadhviVisitForms/${row._id}`);
  };

  const handleClose = () => {
    setOpen(false);
    setSelected(null);
  };


  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await ApiCallService.get(
        `${process.env.REACT_APP_BASE_URL}/sadhu-sadhvi-visit   `
      );
      setRows(res?.data || []);
    } catch (err) {
      console.error("API Error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);



  const columns = [
    {
      field: "sadhuName",
      headerName: "Sadhu Name",
      minWidth: 160,
    },
    {
      field: "location",
      headerName: "Location",
      minWidth: 280,
      disableSort: true,
      searchKey: (row) =>
        `${row.state?.stateName} ${row.district?.districtName} ${row.taluka?.talukaName} ${row.village?.villageName}`,
      renderCell: (row) => (
        <Box>
          {row.state?.stateName}, {row.district?.districtName},{" "}
          {row.taluka?.talukaName}, {row.village?.villageName}
        </Box>
      ),
    },
    {
      field: "contactPerson",
      headerName: "Contact Person",
      minWidth: 160,
    },
    {
      field: "contactNumber",
      headerName: "Contact Number",
      minWidth: 140,
    },
    {
      field: "visitDate",
      headerName: "Visit Date",
      minWidth: 130,
    },
   
    {
      field: "action",
      headerName: "Action",
      minWidth: 100,
      disableSort: true,
      disableSearch: true,
      renderCell: (row) => (
        <IconButton onClick={() => handleOpen(row)}>
          <VisibilityIcon />
        </IconButton>
      ),
    },
  ];

  return (
    <Box p={2}>
      <Typography variant="h5" fontWeight={600} mb={2}>
        Sadhu / Sadhvi Visit Records
      </Typography>

      <ReactTable
        columns={columns}
        rows={rows}
        loading={loading}
        rowKey="_id"
        initialRowsPerPage={5}
        totalRows={rows.length}
      />

      {/* DETAIL DIALOG */}
      {/* <VisitDetailDialog
        open={open}
        onClose={() => setOpen(false)}
        data={selected}
      /> */}










  <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>
          Visit Details
          <IconButton
            onClick={handleClose}
            sx={{ position: "absolute", right: 10, top: 10 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          {selected && (
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Card>
                  <CardContent>
                    <Typography variant="h6">Basic Info</Typography>

                    <Stack spacing={1} mt={2}>
                      <Typography><b>Sadhu Name:</b> {selected.sadhuName}</Typography>
                      <Typography><b>Contact Person:</b> {selected.contactPerson}</Typography>
                      <Typography><b>Contact Number:</b> {selected.contactNumber}</Typography>
                      <Typography><b>Sthanak:</b> {selected.sthanak}</Typography>
                      <Typography><b>Visit Date:</b> {selected.visitDate} {selected.visitTime}</Typography>
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} md={6}>
                <Card>
                  <CardContent>
                    <Typography variant="h6">Location</Typography>

                    <Stack spacing={1} mt={2}>
                      <Typography><b>State:</b> {selected.state?.stateName}</Typography>
                      <Typography><b>District:</b> {selected.district?.districtName}</Typography>
                      <Typography><b>Taluka:</b> {selected.taluka?.talukaName}</Typography>
                      <Typography><b>Village:</b> {selected.village?.villageName}</Typography>
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12}>
                <Card>
                  <CardContent>
                    <Typography variant="h6">Submitted By</Typography>

                    <Stack spacing={1} mt={2}>
                      <Typography>
                        {selected.submittedBy?.userFirstName}{" "}
                        {selected.submittedBy?.userLastName}
                      </Typography>
                      <Typography>{selected.submittedBy?.emailId}</Typography>
                      <Typography>{selected.submittedBy?.mobileNumber}</Typography>
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} md={6}>
                {selected.visitPhoto1 && (
                  <Card>
                    <CardContent>
                      <Typography variant="h6">Photo 1</Typography>
                      <Box mt={2}>
                        <img
                          src={selected.visitPhoto1}
                          alt="visit1"
                          style={{ width: "100%", borderRadius: 8 }}
                        />
                      </Box>
                    </CardContent>
                  </Card>
                )}
              </Grid>

              <Grid item xs={12} md={6}>
                {selected.visitPhoto2 && (
                  <Card>
                    <CardContent>
                      <Typography variant="h6">Photo 2</Typography>
                      <Box mt={2}>
                        <img
                          src={selected.visitPhoto2}
                          alt="visit2"
                          style={{ width: "100%", borderRadius: 8 }}
                        />
                      </Box>
                    </CardContent>
                  </Card>
                )}
              </Grid>
            </Grid>
          )}
        </DialogContent>
      </Dialog>





    </Box>
  );
};

export default SadhuSadhviVisitView;